module.exports = __webpack_public_path__ + "static/media/HCMM476.4c3e7f29.jpg";